// React
import merge from 'deepmerge';
import { Component } from 'react';
import { connect } from 'react-redux';
import { getCookie, getDeviceKindDependsOnViewPort, setCookie } from '@gerenciatd/next.utils.common'
import getMyData from '@gerenciatd/next.adabyron.telco.client.get-my-data';
import { findOutEnv } from '@gerenciatd/next.utils.environment'
import { actions as mainActions } from '@gerenciatd/next.app-controller.reducers-sagas.main-reducer-n';
import {getSegment} from '@gerenciatd/next.utils.context';
import { actions as custoActions } from '@/reducers/custo-reducer';
import {
  checkTcolApiAllowed,
  getMockedContext,
  tranformXcol2Ip3Hashes,
  isNovum,
  composeI3Object,
  mergeIp3gHashes,
  isTelcoSite,
  isTelcoBuyProcess,
  getTabId,
  setSegmentCookie,
  generatePageId
} from './utils';
import { updateGetEg } from './geteg'
import { normalizeInfoContexto, DEFAULT_RESPONSE as  DEFAULT_RESPONSE_ON_ERROR} from './ccli/normalizer';

const filePath = 'route-handler-n';
const EVENT_TYPES = {
  VIEW: 'view',
  LOADED: 'printed',
}

async function makeUpCustoParams(context, onDone){
  try {
      const commonModule = await import('@gerenciatd/next.utils.common');
        const urlParams = commonModule.getUrlParams(true, [
          /recomEnterprise/g,
          /percentile/g,
          /levCode/g,
          /prodCode/g,
          /promoCode/g,
          /ctz_c/g,
          /turingDev/g,
          /productOffering/g,
          /webCode/g,
          /context.*/g,
          /custoHost/g,
          /businessClusters/g,
          /recomType/g,
          /userType/g,
          /ctzTest/g,
        ]);
        const {
          subseg,
          gwIspI3D,
          gwIsp,
          userType,
          clientIDs,
          device,
          i3Ready,
          pageSegment,
          userPriority,
          creativitiesHistory,
          referalAP,
          userCUCFijoHash,
          userCUCMovilHash,
          userIdPartyHash,
        } = context;
        let custoObject = {
          i3Ready,
          SEG_NAV: pageSegment,
          i3_cuc: userCUCFijoHash,
          i3_cucm: userCUCMovilHash,
          i3_idp: userIdPartyHash,
          ga: clientIDs.ga,
          pageId: clientIDs.pageId,
          paid: clientIDs.sessId,
          ctz_c: 'true',
          originUrl: window.location.href,
          context: {
            subseg,
            creativitiesHistory,
            gw_isp: gwIsp,
            gw_isp_d: gwIspI3D,
            isLogado: userType ? 'true' : 'false',
            tipoUsuario: userType,
            deviceType: device,
            seg_nav: pageSegment,
            isPriority: userPriority ? 'true' : 'false',
            referal_ap: referalAP,
          },
        };

        if (urlParams.context && typeof urlParams.context === 'object') {
          urlParams.context = {
            ...custoObject.context,
            ...urlParams.context,
          };
        }
        custoObject = {
          ...custoObject,
          ...urlParams,
        };
        onDone(custoObject);
  } catch (e) {
    throw new Error(e);
  }  
}


function mergeHashes({ hashesFromInfoContexto }) {
  let hashesFromXCOL = composeI3Object({});
  try {
    const XCOL = sessionStorage.getItem('IC_XCOL_ENCODED')
    hashesFromXCOL = tranformXcol2Ip3Hashes(XCOL)
  } catch(err) {
    // cookie mal formada
  }
  return mergeIp3gHashes(hashesFromInfoContexto, hashesFromXCOL);
}

class RouteHandler extends Component {
  getContextSeoInfo = () => {
    const { currentSeo } = this.props;
    return {
      contextSeoMeta: currentSeo && currentSeo.description,
      pageName: currentSeo && currentSeo.page_name,
      productName: currentSeo && currentSeo.product_name,
    }
  }

  getReadyGA = () => {
    let ga = getCookie('_ga') || '';
    const gaTokkens = ga.split('.');
    if (gaTokkens.length > 2) {
      ga = gaTokkens.slice(2).join('.');
    }
    return ga;
  }

  getSessId = () => {
    let sessId = getCookie('_mc_sessid');
    if(!sessId){
      sessId = `${new Date().getTime()}`;
      setCookie('_mc_sessid', sessId, undefined, '.movistar.es');
    }
    return sessId
  }

  createInitialContextObj = () => {
    const { throwSonda } = this.props;
    let initialContextData = {}
      try {
        const timeStamp = Date.now();
        const pageSegment = getSegment();
        setSegmentCookie(pageSegment, throwSonda);
        const pageId = generatePageId();
        window.pageId = pageId;
        initialContextData = {
          numLocationChanges: 0,
          infoRecom: null,
          eventType: EVENT_TYPES.VIEW,
          servicesReady: {},
          tabId: getTabId(),
          pageWebCode: null,
          pageName: null,
          pageWebName: null,
          pageProductCode: null,
          pageProductName: null,
          clientIDs: {
            pageId,
            ga: this.getReadyGA(),
            sessId: this.getSessId(),
          },
          userAgent: window.navigator.userAgent,
          userType: '',
          infoContextApiFailed: false,
          managerInfo: null,
          isWebView: isNovum(throwSonda),
          userConsentCookieOneTrust: null,
          pageSegment,
          contextURL: window.location.href,
          subseg: false,
          userPriority: false,
          gwIsp: getCookie('gwIsp'),
          gwIspI3D: getCookie('gwIsp_i3_d'),
          device: getDeviceKindDependsOnViewPort(),
          contextSeoMeta: null,
          i3Ready: timeStamp,
          pageInfoReady: false,
          referalAP: (document && document.referrer) || '',
          environment: findOutEnv('movistar.es'),
          testVersion: null,
          testName: null,
          testDisable: null,
          version: `${process.env.NEXT_PUBLIC_VERSION_JS}` || 'unknown',
          ...this.getContextSeoInfo(),
        };

        return initialContextData;
      } catch (error) {
        const { throwSonda } = this.props;
        throwSonda({
          kind: 'FATAL',
          processName: 'createInitialContextObj',
          filePath,
          error,
        });
        return initialContextData;
      }
  }

  getClientInfoFromApi = async ({
    setCustoParams,
    setContextData,
    pageLoadedFunction,
    context,
    throwSonda,
  }) => {


    // INFO CONTEXTO
    const envName = context.environment.name;
    const maybeMocked = getMockedContext(envName);
    const contextWithPosibleMock = merge(context, maybeMocked);
    let result = {
      ...DEFAULT_RESPONSE_ON_ERROR,
      contextVars: {
        userType: (isTelcoBuyProcess() || isTelcoSite()) ? 'Telco' : '',
      },
      xCol4Hashes: mergeHashes({hashesFromInfoContexto: {}}),
    };
    try {
      const modules = await Promise.all([
        import('./ccli/'),
        import('./geteg'),
      ])      
      let getInfoModule= modules[0];
      getInfoModule = getInfoModule.default;
      let getEgModule = modules[1];
      getEgModule = getEgModule.default;

      let data = {};
      if (typeof window !== 'undefined' && window.location.href.indexOf('prod.cms') === -1) {
          // paralelizo ambas peticiones
          const infoFromPromises = await Promise.all([
            getInfoModule({context: contextWithPosibleMock}),
            getEgModule(),
          ])
          data = normalizeInfoContexto(infoFromPromises[0]);
      }
      const { xCol4Hashes, contextVars } = data;
      const xCol4HashesFromApi = tranformXcol2Ip3Hashes(xCol4Hashes);

      result = {
        contextVars:{
          ...result.contextVars,
          ...contextVars,
        },
      };
      // aqui los vamos a tener calculados con IC
      result.xCol4Hashes = mergeHashes({
        hashesFromInfoContexto: xCol4HashesFromApi,
      });
      result.contextVars = {
        ...result.contextVars,
      }
      /* -------------------------------------------------------------------------- */
      /*                         Enriquecimiento de la xCOL con servicioI3          */
      /* -------------------------------------------------------------------------- */
  
      // Enriquecemos cuando no tenemos idparty
      if ( // Este if es solo para enriquecimiento de la XCOL en Logado Telco
        result
        && result.contextVars
        && result.contextVars.userType === 'Telco'
        && !result.xCol4Hashes.userIdPartyHash
        && checkTcolApiAllowed()) {
        const initialDataChanged = {
          ...contextWithPosibleMock,
          ...result.contextVars,
          userType: 'Telco',
        }
        // Rwalizamos la promise para obtener más info
        getMyData({context: initialDataChanged, idFront: 'TC', build: false, allowRedirection: false }).then(({ xcol }) => {
          const hashesFromMisDatos = tranformXcol2Ip3Hashes(xcol);
          // Redefinimos para cuando obtengo xcol de misDAtos
          // comprobar y combinar...
          result = {
            ...result,
            xCol4Hashes: {
              ...result.xCol4Hashes,
              ...hashesFromMisDatos,
            },
          }
        })
      } else {
        // si no hay que enriquecer con mis DAtos caigo aki
        // Por este else pueden entrar no logados/legado/telco sin necesidad de enriquecer
        const mocked = getMockedContext(envName) || {}
        result.contextVars = merge(result.contextVars,mocked);
      }
    } catch(err){
      console.error(err);
      // PROCESO CUANDO CUANDO INFO CONTEXT DA ERROR
      throwSonda({
        error: err,
        processName: 'request/cli/getInfoContextFromCCLI',
        severidad: 'ERROR',
        info: 'El api infocontexto ha fallado',
        context: contextWithPosibleMock,
      });
    }








    // HTERMOS TERMINADO DE MIRAR HASHES Y TAL AHORA EL EVENTO
    const loadedEvent = { eventType: EVENT_TYPES.LOADED };
    const viewEvent = { eventType: EVENT_TYPES.VIEW };
    const newContext = {
      ...context,
      ...result.contextVars,
      ...result.xCol4Hashes,
      ...loadedEvent,
    }
    makeUpCustoParams(newContext, setCustoParams),
    setContextData(newContext);
    pageLoadedFunction(newContext, viewEvent)
    pageLoadedFunction(newContext, loadedEvent)

    
  }

  sendPageEvent = (context, eventObj) => {
    const { throwSonda, sendCmsEvent } = this.props;
    let newContext = {
      ...context,
      ...eventObj,
    }
    try {
      const metricsImport = import('@gerenciatd/next.utils.metrics');
      metricsImport.then((metrics) => {
        const { createPageEventObject, extractUserProperties, extractMainProperties } = metrics;
        const data = createPageEventObject(newContext);
        // comportamiento para esperar a GTM
        let interval = null;
        let retries = 10;
        const TIME_BETWEEN_RETRIES = 25;
        if(`${process.env.NEXT_PUBLIC_GTM_USAGE}` === 'true') {
          interval = setInterval(() => {
            if (window.dataLayerGTM) {
              window.dataLayerGTM.push(data);
              clearInterval(interval);
            }
            if (retries < 0) {
              clearInterval(interval);
              throwSonda({
                kind: 'ERROR',
                processName: 'sendPageEvent',
                filePath,
                info: "No se creó el array window.datalayerGTM",
              });
            }
            retries = retries - 1;
          },TIME_BETWEEN_RETRIES)
        } else {
          // Event view, buen punto para el set general de ga
          if (data && data['event-type'] === 'view') {
            // inicializo config
            const mainProperties = extractMainProperties(data);
            const userProperties = extractUserProperties(data);
            let optanon = getCookie('OptanonConsent');
            optanon = decodeURIComponent(optanon);
            const ad_storage = optanon.indexOf('C0004:1') !== -1 ? 'granted' : 'denied';
            const analytics_storage = optanon.indexOf('C0002:1') !== -1 ? 'granted' : 'denied';
            if (ad_storage !== 'denied' || analytics_storage !== 'denied') {
              gtag('consent', 'update', {
                'ad_storage': ad_storage,
                'analytics_storage': analytics_storage,
              });
            }
            gtag('config', `${process.env.NEXT_PUBLIC_GTM_ID}`, {
              transport_url: 'https://landings.dev.col.movistar.es',
              first_party_collection: true,
              ...mainProperties,
              ...userProperties,
            })
          } else {
            sendCmsEvent(data)
          }
        }
      })
    } catch(error) {
      console.error(error);
      throwSonda({
        kind: 'FATAL',
        processName: 'sendPageEvent',
        filePath,
        error,
      });
    }
  }

  componentDidMount(){
    const { setContextData, throwSonda,setCustoParams, setSCXStatus } = this.props;
    // construyo context inicial + seo y guardo en redux, envio el pageview
    const context = this.createInitialContextObj();
    import('@gerenciatd/next.utils.ping-cms-page').then(pingModule => {
      // ping a cms page
      pingModule = pingModule.default;
      let ping = new pingModule({ context });
      ping.sendPingCmsPage();
    });
    // envio pageView
    const viewEvent = { eventType: EVENT_TYPES.VIEW }
    // this.sendPageEvent(context, { eventType: EVENT_TYPES.VIEW }) Hhacemos el envio cuando tenemos el idpary
    setContextData({
      ...context,
      ...viewEvent,
    })
    // llamo a info contexto, mando al finalizar el pageloaded
    this.getClientInfoFromApi({
      setCustoParams,
      setContextData,
      pageLoadedFunction: this.sendPageEvent,
      context,
      throwSonda,
    });
  }

  render(){
    return null
  }
}

const mapStateToProps = (state) => ({
  currentSeo: state.main.currentSeo
});

const mapDispatchToProps = (dispatch) => ({
  sendCmsEvent: data => dispatch(mainActions.sendCmsEvent(data)),
  setSCXStatus: status => dispatch(mainActions.setSCXStatus(status)),
  setContextData: newData => dispatch(mainActions.setContextData(newData)),
  throwSonda: (data) => dispatch(mainActions.throwSonda(data)),
  setCustoParams: (data) => dispatch(custoActions.setCustoParams(data)),
});


export default connect(mapStateToProps, mapDispatchToProps)(RouteHandler)
